export default {
  onlyRead: "Only reading",
  onlyReadTip: `
        You have only <b>a read access</b>. <br/> <br/>
        In order to edit info, please contact your collective organiser.
      `,

  standNumber: "Stands",

  pavilion: "Pavilion",
  hall: "Hall",

  colorg: "Collective organiser",

  nav: {
    info: "Exhibition info",
    calendar: "Calendar",
    companyProfile: "Company profile",
    users: "Users",
    subexponents: "Sub-exhibitors",
    servicesOrder: "Order services",
    stands: "Stands",
    order: "Publication in the Catalogue",
    pass: "Passes"
  },

  functionalRole: {
    self: "Exhibitor",
    collective: "Collective organiser",
    mounting: "Assembly organization",
    installer: "Assembly organization",
    sub: "Sub-exhibitor",
    "part-time": "Absentee exhibitor",
    "organizer-and-media": "Event organiser or mass media",
    "special-project": "Participant of a special project"
  }
};
